import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import CodeMirror from "codemirror";
import HalResource from "ulysses/api";
import markup from "ulysses/features/admin/model_admin.html";
import mk_entity from "ulysses/features/admin/entity_editor.html";
import mk_attr from "ulysses/features/admin/attribute_editor.html";
import mk_rel from "ulysses/features/admin/relation_editor.html";
import mk_solr from "ulysses/features/admin/solr_editor.html";
import mk_perms from "ulysses/features/admin/permissions.html";
import mk_act from "ulysses/features/admin/action_editor.html";
import wf from "ulysses/features/admin/workflow_editor.html";
import ade from "ulysses/features/admin/action_dialog_editor.html";
import controls from "ulysses/features/admin/dialog_editor_controls.html";
import "codemirror-modes/python/python";
import "./action_model_editor";
import "ulysses/controls/expressionpicker";

"use strict";
$(document).ready(function () {
    $(markup + mk_entity + mk_attr + mk_rel + mk_solr + mk_perms + mk_act + wf + ade + controls).appendTo($("body"));
});

const TEMPLATE_NAMES = {
    "main": "main_entity_editor_tmpl",
    "attribute": "attribute_editor_tmpl",
    "relation": "relation_editor_tmpl",
    "view": "view_editor_tmpl",
    "action": "action_editor_tmpl",
    "workflow": "workflow_editor_tmpl"
};

ko.bindingHandlers.entityeditor = {
    init: function (elt, va, allbindings, model, context) {
        var entity_model = {
            "known_permissions": ko.observableArray([]),
            "known_roles": ko.observableArray([]),
            "known_themes": ko.observableArray([]),
            "known_statuses": ko.observableArray([]),
            "known_models": ko.observableArray([]),
            "status_to_create": ko.observable(),
            "attributes": ko.observableArray([]),
            "relations": ko.observableArray([]),
            "views": ko.observableArray([]),
            "model_actions": ko.observableArray([]),
            "workflow_actions": ko.observableArray([]),
            "workflows": ko.observableArray([]),
            "selectedType": ko.observable("main"),
            "selection": ko.observable(),
            "selectedTemplate": ko.pureComputed(function () {
                return TEMPLATE_NAMES[entity_model.selectedType()];
            }),
            is_action: ko.observable(),
            "showMainInformation": function (ui, ev) {
                entity_model.selectedType(null);
                entity_model.selection(ko.unwrap(entity_model.main));
                entity_model.selectedType("main");
            },
            "showAttribute": function (a, ev) {
                entity_model.selectedType(null);
                entity_model.selection(a);
                entity_model.selectedType("attribute");
            },
            "showRelation": function (r, ev) {
                entity_model.selectedType(null);
                entity_model.selection(r);
                entity_model.selectedType("relation");
            },
            "showView": function (v, ev) {
                entity_model.selectedType(null);
                entity_model.selection(v);
                entity_model.selectedType("view");
            },
            "showWorkflow": function (w, ev) {
                entity_model.selectedType(null);
                entity_model.selection(w);
                entity_model.selectedType("workflow");
            },
            "showAction": function (a, ev) {
                entity_model.selectedType(null);
                entity_model.selection(a);
                entity_model.selectedType("action");
            },
            "activateMenu": function (ui, ev) {
                var sub = $(ev.target).closest(".menu-container").find("ul");
                if (sub.hasClass("menu-open")) {
                    sub.removeClass("menu-open");
                    sub.fadeOut();
                } else {
                    sub.fadeIn();
                    sub.addClass("menu-open");
                }
            },
            "saveEntity": function (ui, ev) {
                console.log("ui:", ui, ko.toJS(ui));
                //Now we need to rebuild a useful payload
                var payload = {};
                var source = ko.toJS(ui);
                ["entityName", "caption", "icon", "colour", "description", "is_config_data", "is_labelled", "is_journalled", "is_addressed", "is_pictured", "is_entitled", "scripts", "relationship_permissions", "role_permissions", "category"].map(
                    function (k) {
                        payload[k] = source[k];
                    }
                );

                var indexing = source.indexing;
                payload.indexing = {
                    "is_indexed": indexing.is_indexed,
                    "extra_mapped_fields": indexing.extra_mapped_fields.split("\n"),
                    "subtitle_template": ko.unwrap(indexing.subtitle_template),
                    "snippet_template": ko.unwrap(indexing.snippet_template),
                    "themes": {}
                };

                indexing.themes.map(function (kt) {
                    if (
                        (kt.subtitle_template && kt.subtitle_template.length) ||
                        (kt.snippet_template && kt.snippet_template.length)
                    ) {
                        payload.indexing.themes[kt.name] = {
                            subtitle_template: kt.subtitle_template,
                            snippet_template: kt.snippet_template
                        };
                    }
                });

                var entityRes = HalResource(uly.utils.get_bound_resource(context));
                console.log("got payload:", payload, entityRes);
                entityRes.put(null, payload).then(function (result) {
                    uly.utils.show_results(result);
                }).fail(function (error) {
                    uly.utils.show_results(error);
                });
                return false;
            },
            addRolePermission: function (ui, ev) {
                ko.unwrap(entity_model.main).role_permissions.push({
                    "role": ko.observable(),
                    "permissions": ko.observableArray([])
                });
            },
            resetRolePermissions: function (ui, ev) {},
            deleteRolePermission: function (ui, ev) {
                var idx = ko.unwrap(entity_model.main).role_permissions.indexOf(ui);
                if (idx >= 0) {
                    ko.unwrap(entity_model.main).role_permissions.splice(idx, 1);
                }
            },
            addRelationshipPermission: function (ui, ev) {
                ko.unwrap(entity_model.main).relationship_permissions.push({
                    "roles": ko.observableArray([]),
                    "permissions": ko.observableArray([]),
                    "path": {
                        "kind": ko.observable("field"),
                        "expression": ko.observable()
                    },
                    "val": {
                        "kind": ko.observable("field"),
                        "expression": ko.observable()
                    }
                });
            },
            resetRelationshipPermissions: function (ui, ev) {},
            deleteRelationshipPermission: function (ui, ev) {
                var idx = ko.unwrap(entity_model.main).relationship_permissions.indexOf(ui);
                if (idx >= 0) {
                    ko.unwrap(entity_model.main).relationship_permissions.splice(idx, 1);
                }
            },

            addInheritor: function (ui, ev) {
                ui.inherit_from.push({
                    "path": {
                        "kind": ko.observable("field"),
                        "expression": ko.observable()
                    },
                    "condition": {
                        "kind": ko.observable("field"),
                        "expression": ko.observable()
                    },
                    "override": ko.observable(false)
                });

            },
            resetInheritors: function (ui, ev) {},
            deleteInheritor: function (ui, ev) {
                var attribute = entity_model.selection();
                var idx = attribute.inherit_from.indexOf(ui);
                if (idx >= 0)
                    attribute.inherit_from.splice(idx, 1);
            },
            addTimedEvent: function (ui, ev) {
                ui.timed_events.push({
                    "offset": {
                        "kind": ko.observable("field"),
                        "expression": ko.observable()
                    },
                    "action": {
                        "kind": ko.observable("script"),
                        "expression": ko.observable()
                    },
                    "cancel_script": {
                        "kind": ko.observable("script"),
                        "expression": ko.observable()
                    },
                    "reset_script": {
                        "kind": ko.observable("script"),
                        "expression": ko.observable()
                    }
                });
            },
            deleteTimedEvent: function (ui, ev) {
                var attribute = entity_model.selection();
                var idx = attribute.inherit_from.indexOf(ui);
                if (idx >= 0)
                    attribute.inherit_from.splice(idx, 1);
            },
            resetTimedEvents: function (ui, ev) {},
            addAttribute: function (ui, ev) {
                var a = {
                    "is_system": false,
                    "caption": ko.observable(),
                    "name": ko.observable("new_attribute"),
                    "type": ko.observable("name"),
                    "read_only": ko.observable(false),
                    "is_indexed": ko.observable(true),
                    "description": ko.observable(),
                    "change_script": ko.observable(),
                    "inherit_from": ko.observableArray([]),
                    "timed_events": ko.observableArray([])
                };
                a.is_timed = ko.pureComputed(function () {
                    return ko.unwrap(a.type) == "datetime";
                });
                entity_model.attributes.push(a);
                entity_model.showAttribute(a);
            },
            saveAttribute: function (ui, ev) {
                var payload = ko.toJS(ui);
                payload.todo = "attribute";
                var entityRes = HalResource(uly.utils.get_bound_resource(context));
                console.log("got payload:", payload, entityRes);
                entityRes.post(null, payload).then(function (result) {
                    uly.utils.show_results(result);
                    entity_model.refreshAttributes(entityRes.follow("self"));
                }).fail(function (error) {
                    uly.utils.show_results(error);
                });
            },
            refreshAttributes: function (entityRes) {
                var self = this;
                entityRes.follow("uly:attributes").then(function (attributes) {
                    self.attributes(attributes.map(function (srcAttr) {
                        var attr = {
                            "caption": ko.observable(srcAttr.caption),
                            "name": ko.observable(srcAttr.name),
                            "id": ko.observable(srcAttr.name),
                            "type": ko.observable(srcAttr.type),
                            "read_only": ko.observable(srcAttr.read_only || false),
                            "is_indexed": ko.observable(srcAttr.is_indexed),
                            "description": ko.observable(srcAttr.description),
                            "change_script": ko.observable(srcAttr.change_script),
                            "inherit_from": ko.observableArray((srcAttr.inherit_from || []).map(function (h) {
                                return h
                            })),
                            "timed_events": ko.observableArray((srcAttr.timed_events || []).map(function (h) {
                                return h
                            })),
                            "is_system": true
                        };
                        attr.is_timed = ko.pureComputed(function () {
                            return ko.unwrap(attr.type) == "datetime";
                        });
                        return attr;
                    }));
                });
            },
            addRelation: function (ui, ev) {
                var r = {
                    "is_system": false,
                    "caption": ko.observable(),
                    "name": ko.observable("new_relation"),
                    "type": ko.observable("name"),
                    "multiplicity": ko.observable("one"),
                    "bidirectional": ko.observable(false),
                    "read_only": ko.observable(false),
                    "is_indexed": ko.observable(true),
                    "description": ko.observable(),
                    "change_script": ko.observable(),
                    "inherit_from": ko.observableArray([]),
                    "reverse_name": ko.observable()
                };
                entity_model.relations.push(r);
                entity_model.showRelation(r);
            },
            saveRelation: function (ui, ev) {
                var payload = ko.toJS(ui);
                payload.todo = "relation";
                var entityRes = HalResource(uly.utils.get_bound_resource(context));
                console.log("got payload:", payload, entityRes);
                entityRes.post(null, payload).then(function (result) {
                    uly.utils.show_results(result);
                    entity_model.refreshRelations(entityRes.follow("self"));
                }).fail(function (error) {
                    uly.utils.show_results(error);
                });
            },
            refreshRelations: function (entityRes) {
                var self = this;
                entityRes.follow("uly:relations").then(function (relations) {
                    self.relations(relations.map(function (srcRel) {
                        var rel = {
                            "caption": ko.observable(srcRel.caption),
                            "name": ko.observable(srcRel.name),
                            "id": ko.observable(srcRel.name),
                            "type": ko.observable(srcRel.type),
                            "read_only": ko.observable(srcRel.read_only || false),
                            "multiplicity": ko.observable(srcRel.multiplicity || "one"),
                            "bidirectional": ko.observable(srcRel.bidirectional || false),
                            "is_indexed": ko.observable(srcRel.is_indexed),
                            "description": ko.observable(srcRel.description),
                            "change_script": ko.observable(srcRel.change_script),
                            "inherit_from": ko.observableArray((srcRel.inherit_from || []).map(function (h) {
                                return h;
                            })),
                            "reverse_name": ko.observable(srcRel.reverse_name),
                            "is_system": true
                        };
                        return rel;
                    }));
                });
            },
            refreshWorkflows: function (entityRes) {
                var self = this;
                entityRes.follow("uly:workflows").then(function (workflows) {
                    self.workflows(workflows.map(function (srcWorkflow) {
                        return {
                            "self": srcWorkflow._links.self,
                            "name": ko.observable(srcWorkflow.name),
                            "entities": ko.observableArray(srcWorkflow.entities || []),
                            "states": ko.observableArray($.map(srcWorkflow.workflow || [], function (state) {
                                return {
                                    "status": ko.observable(state.status),
                                    "actions": ko.observableArray((state.actions || []).map(function (act) {
                                        var s = {
                                            "action": ko.observable(act.action),
                                            "only_if": ko.observable(act.only_if || null)
                                        };
                                        return s;
                                    })),
                                    "next_action": ko.observableArray(state.next_action || [])
                                };
                            }))
                        };
                    }));
                });
            },
            addWorkflowAction: function (ui, ev) {
                ui.actions.push({
                    "action": ko.observable(),
                    "only_if": ko.observable()
                });
            },
            moveWorkflowActionUp: function (ui, ev) {
                var actions = ko.contextFor(ev.target).$parent.actions;
                var idx = actions().indexOf(ui);
                if (idx > 0) {
                    actions.splice(idx, 1);
                    actions.splice(idx - 1, 0, ui);
                }
            },
            moveWorkflowActionDown: function (ui, ev) {
                var actions = ko.contextFor(ev.target).$parent.actions;
                var idx = actions().indexOf(ui);
                if (idx < actions().length - 1) {
                    actions.splice(idx, 1);
                    actions.splice(idx + 1, 0, ui);
                }
            },
            removeWorkflowAction: function (ui, ev) {
                var actions = ko.contextFor(ev.target).$parent.actions;
                var idx = actions().indexOf(ui);
                if (idx >= 0) {
                    actions.splice(idx, 1);
                }
            },
            addWorkflowStatus: function (ui, ev) {
                var status = entity_model.status_to_create();
                if (status && ui.states().filter(function (s) {
                        return s.key_code == status;
                    }).length <= 0) {
                    ui.states.push({
                        "status": ko.observable(status),
                        "actions": ko.observableArray([]),
                        "next_action": ko.observableArray([])
                    });
                    entity_model.status_to_create(null);
                }
            },
            moveWorkflowStateUp: function (ui, ev) {
                var states = ko.contextFor(ev.target).$parent.states;
                var idx = states().indexOf(ui);
                if (idx > 0) {
                    states.splice(idx, 1);
                    states.splice(idx - 1, 0, ui);
                }
            },
            moveWorkflowStateDown: function (ui, ev) {
                var states = ko.contextFor(ev.target).$parent.states;
                var idx = states().indexOf(ui);
                if (idx < states().length - 1) {
                    states.splice(idx, 1);
                    states.splice(idx + 1, 0, ui);
                }
            },
            removeWorkflowState: function (ui, ev) {
                var states = ko.contextFor(ev.target).$parent.states;
                var idx = states().indexOf(ui);
                if (idx >= 0) {
                    states.splice(idx, 1);
                }
            },
            addWorkflow: function (ui, ev) {
                var newWorkflow = {
                    "name": ko.observable(),
                    "states": ko.observableArray([]),
                    "entities": ko.observableArray([ko.unwrap(entity_model.main().name)])
                };
                ui.workflows.push(newWorkflow);
                entity_model.showWorkflow(newWorkflow);
                ev.stopPropagation();
            },
            saveWorkflow: function (ui, ev) {
                var wkf = ko.toJS(ui);
                var workflow = {
                    "name": wkf.name || "",
                    "entities": wkf.entities || [],
                    "workflow": wkf.states.map(function (state) {
                        return {
                            "status": state.status,
                            "actions": state.actions.map(function (a) {
                                var s = {
                                    "action": a.action
                                };
                                if (a.only_if)
                                    s.only_if = a.only_if;
                                return s;
                            }),
                            "next_action": state.actions.length ? [state.actions[0].name] : []
                        };
                    })
                };
                var res = null;
                if (wkf.self) {
                    res = HalResource(wkf.self.href).put(null, workflow);
                } else {
                    res = uly.api.start().follow("uly:admin").post("uly:workflow", workflow);
                }
                var entityRes = HalResource(uly.utils.get_bound_resource(context));
                res.then(function (i) {
                    uly.utils.show_results(i);
                    entity_model.showMainInformation();
                    entity_model.refreshWorkflows(entityRes);
                }, function (e) {
                    uly.utils.show_results(e);
                });

            },
            addStandardAction: function (ui, ev) {
                var action = {
                    "name": ko.observable(),
                    "entities": ko.observableArray([]),
                    "set": ko.observable("workflow"),
                    "caption": ko.observable(),
                    "colour": ko.observable("default"),
                    "icon": ko.observable("fa-bolt"),
                    "description": ko.observable(),
                    "cli_enabled": ko.observable(false),
                    "cli_description": ko.observable(),
                    "cli_name": ko.observable(),
                    "code": ko.observable(),
                    "server_code": ko.observable(),
                    "do_index": ko.observable(),
                    "roles": ko.observableArray(["Administrator"]),
                    "permission": ko.observable("edit"),
                    "dialog_name": ko.observable(),
                    "is_bulk": ko.observable(false),
                    "is_user_defined": true,
                    "action_class": "standard",
                    "action_model": {
                        "fields": ko.observableArray([]),
                        "transitions": ko.observableArray([])
                    },
                    "dialog": ko.observable(null)
                };
                action.has_dialog = ko.pureComputed(function () {
                    return action.dialog_name != null;
                });
                entity_model.model_actions.push(action);
                entity_model.showAction(action);
                ev.stopPropagation();
            },
            addClientAction: function (ui, ev) {
                var action = {
                    "name": ko.observable(),
                    "entities": ko.observableArray([]),
                    "set": ko.observable("workflow"),
                    "caption": ko.observable(),
                    "colour": ko.observable("default"),
                    "icon": ko.observable("fa-bolt"),
                    "description": ko.observable(),
                    "code": ko.observable(),
                    "do_index": ko.observable(),
                    "roles": ko.observableArray(["Administrator"]),
                    "permission": ko.observable("edit"),
                    "is_bulk": ko.observable(false),
                    "is_user_defined": true,
                    "action_name": ko.observable(),
                    "link": ko.observable(),
                    "action_class": "client"
                };
                entity_model.model_actions.push(action);
                entity_model.showAction(action);
                ev.stopPropagation();
            },
            saveAction: function (ui, ev) {
                var srcAction = ko.toJS(ui);
                var action = srcAction;
                delete action.has_dialog;
                action.server_code = {
                    "expression": action.server_code || null
                };
                var res;
                if (action.self) {
                    res = HalResource(action.self.href).put(null, action);
                } else {
                    res = uly.api.start().follow("uly:admin").post("uly:action", action);
                }
                var entityRes = HalResource(uly.utils.get_bound_resource(context));
                res.then(function (i) {
                    uly.utils.show_results(i);
                    entity_model.showMainInformation();
                    entity_model.refreshActions(entityRes);
                }, function (e) {
                    uly.utils.show_results(e);
                });
            },
            refreshActions: function (entityRes) {
                var self = this;
                entityRes.follow("uly:model_actions").then(function (actions) {
                    actions = actions.map(function (action) {
                        var res = {
                            "self": action._links.self,
                            "name": ko.observable(action.name),
                            "entities": ko.observableArray(action.entities || []),
                            "action_name": ko.observable(action.action_name),
                            "caption": ko.observable(action.caption),
                            "colour": ko.observable(action.colour),
                            "icon": ko.observable(action.icon),
                            "set": ko.observable(action.set_),
                            "roles": ko.observableArray(action.roles),
                            "permission": ko.observable(action.permission),
                            "description": ko.observable(action.description),
                            "code": ko.observable(action.code),
                            "action_class": action.action_class
                        };
                        if (action.action_class == "standard") {
                            $.extend(res, {
                                "dialog_name": ko.observable(action.dialog_name),
                                "has_dialog": ko.pureComputed(function () {
                                    return ko.unwrap(res.dialog_name) != null;
                                }),
                                "do_index": ko.observable(action.do_index),
                                "server_code": ko.observable(action.server_code ? action.server_code.expression : ""),
                                "action_model": {
                                    "fields": ko.observableArray(action.action_model && action.action_model.fields ? action.action_model.fields : []),
                                    "transitions": ko.observableArray(action.action_model && action.action_model.transitions ? action.action_model.transitions : [])
                                },
                                "cli_enabled": ko.observable(action.cli_enabled),
                                "cli_name": ko.observable(action.cli_name),
                                "cli_description": ko.observable(action.cli_description),
                                "dialog": ko.observable({})
                            });
                        } else {
                            $.extend(res, {
                                "link": ko.observable(action.link)
                            });
                        }
                        return res;
                    });
                    self.model_actions(actions);
                    self.workflow_actions(actions.filter(function (a) {
                        return ko.unwrap(a.set) == "workflow";
                    }));
                });
            }
        };

        $(elt).data("entityeditor", entity_model);
        //TODO: hack to get list of known permissions
        var admin = uly.api.start().follow("uly:admin");
        var themes = admin.follow("uly:theme").then(function (result) {
            entity_model.known_themes(result.data);
        });

        var security = admin.follow("uly:security").then(function (result) {
            entity_model.known_permissions(result.permissions);
            entity_model.known_roles(result.roles);
        });

        var statuses = uly.api.start().follow("uly:data").follow("uly:actionstatus", {
            "nodata": 1
        }).follow("uly:lookup").then(function (result) {
            entity_model.known_statuses(result.items);
        });

        var models = admin.follow("uly:model").then(function (result) {
            var models = Array.prototype.concat.apply([], result.data.models.map(function (cat) {
                return cat.models;
            }));
            entity_model.known_models(models);
        });

        entity_model.is_action(ko.unwrap(ko.unwrap(va()).is_action));
        Promise.when(themes, security).then(function () {
            console.log("calculating main");
            entity_model.main = ko.pureComputed(function () {
                var main = $.extend({}, ko.unwrap(va()));
                var idxing = $.extend({}, main.indexing);
                main.indexing = idxing;
                main.indexing.extra_mapped_fields = ko.observable(ko.unwrap(main.indexing.extra_mapped_fields).join("\n"));
                var original_themes = idxing.themes;
                idxing.themes =
                    entity_model.known_themes().map(function (kt) {
                        if (original_themes && original_themes[kt.name]) {
                            var theme = original_themes[kt.name];
                            return $.extend({}, kt, {
                                "snippet_template": ko.observable(theme.snippet_template),
                                "subtitle_template": ko.observable(theme.subtitle_template)
                            });
                        } else {
                            return $.extend({}, kt, {
                                "snippet_template": ko.observable(),
                                "subtitle_template": ko.observable()
                            });
                        }
                    });
                console.log("Got main:", main);
                return main;
            });
            if (entity_model.selectedType() == "main") {
                entity_model.selection(entity_model.main());
            }
            var childContext = context.createChildContext(entity_model);
            ko.applyBindingsToDescendants(childContext, elt);
        });

        return {
            "controlsDescendantBindings": true
        };
    },
    update: function (elt, va, allbindings, model, context) {
        var entityInfo = ko.unwrap(va());
        var entityModel = $(elt).data("entityeditor");
        var entityRes = HalResource(uly.utils.get_bound_resource(context));
        console.log("entityRes:", entityRes, context, model);
        entityModel.refreshAttributes(entityRes);
        entityModel.refreshRelations(entityRes);
        entityModel.refreshWorkflows(entityRes);
        entityModel.refreshActions(entityRes);
    }
};


//define the mako mime type for embeddding python
CodeMirror.defineMIME("application/x-mako", {
    name: "htmlembedded",
    scriptingModeSpec: "python"
});
ko.bindingHandlers["codeedit"] = {
    "init": function (element, va, bindings, model, context) {
        var editoroptions = ko.unwrap(bindings().codeeditoroptions) || {};
        $.extend(editoroptions, {
            "mode": "python",
            "theme": "vibrant-ink",
            "lineNumbers": true,
            "indentUnit": 4,
            "onBlur": function (ed) {
                var val = ed.getValue();
                if (val == "")
                    val = null;
                va()(val);
            }
        }, editoroptions);
        var on_blur = editoroptions.onBlur;
        var on_show = function () {
            editor.refresh();
        };
        var editor = CodeMirror.fromTextArea(element, editoroptions);
        editor.on("blur", on_blur);
        var $tabs = $(element).parents(".tab-pane");
        var $links = $tabs.map(function (idx, tab) {
            var id = $(tab).attr("id");
            return $(tab).parent().parent().children("ul").find("li a[href='#" + id + "']")[0];
        });
        $links.on("shown.bs.tab", on_show);
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $links.off("shown.bs.tab", on_show);
        });
        $(element).data("codemirror_editor", editor);
        setTimeout(on_show, 0);
    },
    "update": function (element, va, bindings, model, context) {
        var editor = $(element).data("codemirror_editor");
        var val = ko.utils.unwrapObservable(va());
        if (typeof val == "undefined" || val == null) val = "";
        if (editor && editor.getValue() != val)
            editor.setValue(val || "");
    }
};